import request from "../request";
import rewards from "../../services/gma/rewards";
import { GMI, STATE } from "../../constants";
import { isArrayNotEmpty } from "../../utils/js/array";
import redux from "../../utils/redux";

export const { HISTORY, HISTORY_PATH } = STATE.UI.REWARDS;

/**
 * @private
 * @param {String} startDate
 * @returns {Object} {type: string, path: [], value: object}
 */
function setStartDate(startDate) {
  return { type: GMI.SET_GMI_STATE, path: HISTORY.START_DATE, value: startDate };
}

/**
 * @private
 * @param {String} endDate
 * @returns {Object} {type: string, path: [], value: object}
 */
function setEndDate(endDate) {
  return { type: GMI.SET_GMI_STATE, path: HISTORY.END_DATE, value: endDate };
}

/**
 * @private
 * @param {String} pageCount
 * @returns {Object} {type: string, path: [], value: object}
 */
function setTotalPageCount({pageCount, path}) {
  return { type: GMI.SET_GMI_STATE, path, value: pageCount };
}

/**
 * @private
 * @param {*} param0 
 */
function setPageHistory({history, path}) {
  return { type: GMI.SET_GMI_STATE, path, value: history };
}

/**
 * @name history
 * @desc Make the GMA rewards/history call with args or state data
 * @param {Object} [args] {
 *   startDate: '2019-01-19',
 *   endDate: '2019-02-19',
 *   pageNumber: 1
 * }
 * @param {Object} [data] {params}
 * @param {Object} [requestOpts]
 * @returns {Function}
 * @memberof actions.rewards
 * @example
 * store.dispatch(actions.rewards.history(args));
 * 
 * Resulting store will look like
 * rewards: {
 *  history: {
 *    start_date: 'X',
 *    end_date: 'Y',
 *    page_number: 1,
 *    X-Y: {
 *      total_page_count: 5,
 *      pages: {
 *        1: [...]
 *      }
 *    }
 *  }
 * }
 */
export function history(args = {}, data = {}, requestOpts = {}) {
  return (dispatch, getState) => {
    const state = getState();
    const { startDate, endDate, pageNumber } = args;
    const params = {
      startDate: startDate || state.getIn(HISTORY.START_DATE),
      endDate: endDate || state.getIn(HISTORY.END_DATE),
      pageNumber: pageNumber || state.getIn(HISTORY.PAGE_NUMBER)
    };
    Object.assign(data, { params });
    return dispatch(
      request({
        service: rewards.history,
        data,
        opts: requestOpts
      })
    ).then(resp => {
      if (!isArrayNotEmpty(resp.messages)) {
        const {startDate, endDate, pageNumber} = params;
        dispatch(
          redux.batchActions(
            setTotalPageCount({pageCount: resp.total_page_count, path: HISTORY_PATH.concat([`${startDate}-${endDate}`, 'total_page_count'])}),
            setPageHistory({history: resp.account_histories, path: HISTORY_PATH.concat([`${startDate}-${endDate}`, 'pages', pageNumber])}),
            setStartDate(params.startDate),
            setEndDate(params.endDate)
          )
        );
      }
      return resp;
    });
  };
}
